// There might be a temptation to rename or reorder these, but TileType is stored in the database
// as its number. Would have been better if this was stored as a string, but that ship has sailed,
import { CardName } from './cards/CardName';
// for now.
export var TileType;
(function (TileType) {
    TileType[TileType["GREENERY"] = 0] = "GREENERY";
    TileType[TileType["OCEAN"] = 1] = "OCEAN";
    TileType[TileType["CITY"] = 2] = "CITY";
    TileType[TileType["CAPITAL"] = 3] = "CAPITAL";
    TileType[TileType["COMMERCIAL_DISTRICT"] = 4] = "COMMERCIAL_DISTRICT";
    TileType[TileType["ECOLOGICAL_ZONE"] = 5] = "ECOLOGICAL_ZONE";
    TileType[TileType["INDUSTRIAL_CENTER"] = 6] = "INDUSTRIAL_CENTER";
    TileType[TileType["LAVA_FLOWS"] = 7] = "LAVA_FLOWS";
    TileType[TileType["MINING_AREA"] = 8] = "MINING_AREA";
    TileType[TileType["MINING_RIGHTS"] = 9] = "MINING_RIGHTS";
    TileType[TileType["MOHOLE_AREA"] = 10] = "MOHOLE_AREA";
    TileType[TileType["NATURAL_PRESERVE"] = 11] = "NATURAL_PRESERVE";
    TileType[TileType["NUCLEAR_ZONE"] = 12] = "NUCLEAR_ZONE";
    TileType[TileType["RESTRICTED_AREA"] = 13] = "RESTRICTED_AREA";
    TileType[TileType["DEIMOS_DOWN"] = 14] = "DEIMOS_DOWN";
    TileType[TileType["GREAT_DAM"] = 15] = "GREAT_DAM";
    TileType[TileType["MAGNETIC_FIELD_GENERATORS"] = 16] = "MAGNETIC_FIELD_GENERATORS";
    TileType[TileType["BIOFERTILIZER_FACILITY"] = 17] = "BIOFERTILIZER_FACILITY";
    TileType[TileType["METALLIC_ASTEROID"] = 18] = "METALLIC_ASTEROID";
    TileType[TileType["SOLAR_FARM"] = 19] = "SOLAR_FARM";
    TileType[TileType["OCEAN_CITY"] = 20] = "OCEAN_CITY";
    TileType[TileType["OCEAN_FARM"] = 21] = "OCEAN_FARM";
    TileType[TileType["OCEAN_SANCTUARY"] = 22] = "OCEAN_SANCTUARY";
    TileType[TileType["DUST_STORM_MILD"] = 23] = "DUST_STORM_MILD";
    TileType[TileType["DUST_STORM_SEVERE"] = 24] = "DUST_STORM_SEVERE";
    TileType[TileType["EROSION_MILD"] = 25] = "EROSION_MILD";
    TileType[TileType["EROSION_SEVERE"] = 26] = "EROSION_SEVERE";
    TileType[TileType["MINING_STEEL_BONUS"] = 27] = "MINING_STEEL_BONUS";
    TileType[TileType["MINING_TITANIUM_BONUS"] = 28] = "MINING_TITANIUM_BONUS";
    // The Moon
    TileType[TileType["MOON_MINE"] = 29] = "MOON_MINE";
    TileType[TileType["MOON_HABITAT"] = 30] = "MOON_HABITAT";
    TileType[TileType["MOON_ROAD"] = 31] = "MOON_ROAD";
    TileType[TileType["LUNA_TRADE_STATION"] = 32] = "LUNA_TRADE_STATION";
    TileType[TileType["LUNA_MINING_HUB"] = 33] = "LUNA_MINING_HUB";
    TileType[TileType["LUNA_TRAIN_STATION"] = 34] = "LUNA_TRAIN_STATION";
    TileType[TileType["LUNAR_MINE_URBANIZATION"] = 35] = "LUNAR_MINE_URBANIZATION";
    // Pathfinders
    TileType[TileType["WETLANDS"] = 36] = "WETLANDS";
    TileType[TileType["RED_CITY"] = 37] = "RED_CITY";
    TileType[TileType["MARTIAN_NATURE_WONDERS"] = 38] = "MARTIAN_NATURE_WONDERS";
    TileType[TileType["CRASHLANDING"] = 39] = "CRASHLANDING";
    TileType[TileType["MARS_NOMADS"] = 40] = "MARS_NOMADS";
    TileType[TileType["REY_SKYWALKER"] = 41] = "REY_SKYWALKER";
    // Underworld
    TileType[TileType["MAN_MADE_VOLCANO"] = 42] = "MAN_MADE_VOLCANO";
    // Promo
    TileType[TileType["NEW_HOLLAND"] = 43] = "NEW_HOLLAND";
    // Automa
    TileType[TileType["NEURAL_INSTANCE"] = 44] = "NEURAL_INSTANCE";
    // Terrakeeping (SOLAR_FARM (19) is reused for Terrakeeping solar farms.)
    TileType[TileType["WIND_FARM"] = 45] = "WIND_FARM";
    // 46 IS RETIRED AND MUST STAY EMPTY. It was TRANSMISSION_LINK, removed
    // 2026-08-20 once nothing placed one (the tile was retired 2026-08-19 and
    // the cards that laid it now bend the disconnection fee instead - see
    // TERRITORY_FEE). The number is deliberately not reused and COAL_PLANT is
    // pinned below it, because TileType is serialized into saved games by its
    // NUMBER: letting the plants slide up one would silently turn the coal
    // stations in every stored game into something else. A pre-2026-08-20 save
    // that still carries a link draws it as the fallback disc.
    // Neutral pre-existing plants seeded at setup (the starting-year fleet).
    TileType[TileType["COAL_PLANT"] = 47] = "COAL_PLANT";
    TileType[TileType["GAS_PLANT"] = 48] = "GAS_PLANT";
    TileType[TileType["NUCLEAR_PLANT"] = 49] = "NUCLEAR_PLANT";
    TileType[TileType["HYDRO_PLANT"] = 50] = "HYDRO_PLANT";
    // 51 IS RETIRED AND MUST STAY EMPTY, on slot 46's reasoning below. It was
    // OIL_PLANT, removed 2026-08-28 (Dan): no card ever placed one and the only
    // one on any board was the year-2000 fleet's Osaka Bay tile. TIDAL_PLANT is
    // PINNED to 52 rather than left to slide, because TileType is serialized by
    // NUMBER - letting the four plants below move up one would silently turn
    // every tidal station in every stored game into a geothermal one.
    // Player-built site-restricted plants.
    TileType[TileType["TIDAL_PLANT"] = 52] = "TIDAL_PLANT";
    TileType[TileType["GEOTHERMAL_PLANT"] = 53] = "GEOTHERMAL_PLANT";
    TileType[TileType["EXTRACTION"] = 54] = "EXTRACTION";
    TileType[TileType["BIOMASS_PLANT"] = 55] = "BIOMASS_PLANT";
    // RETROFITTED FOSSIL STATIONS (2026-08-25). Carbon Capture Retrofit does
    // not take a station down, it turns the tile over: the plant goes on
    // burning what it burned and generating what it generated, and stops
    // carrying an emission block. Same fuel, same PWh, GREEN HEX - which is
    // why these are separate tile types rather than a flag: every question
    // the board asks about a plant's carbon is asked of its TILE TYPE
    // (`EMITTING_PLANT_TILES` / `CLEAN_PLANT_TILES`), so a retrofitted
    // station answers all of them correctly by being one of these and none
    // of the callers has to learn a new question.
    TileType[TileType["COAL_CCS_PLANT"] = 56] = "COAL_CCS_PLANT";
    TileType[TileType["GAS_CCS_PLANT"] = 57] = "GAS_CCS_PLANT";
    // 58 IS RETIRED AND MUST STAY EMPTY: it was OIL_CCS_PLANT, which went with
    // the oil station it was the capture side of.
    // THE FIRST TILE THAT IS NOT A POWER STATION OR A MINE (2026-08-29). An
    // OTEC platform generates nothing the grid can measure - see the card -
    // so it is deliberately absent from every plant set in PlantTiles.ts and
    // from the fleet tally on the map. What it is, is a landmark: a unique
    // tile that can stand only on a tropical coast, and the first thing on
    // this board that a latitude band decides.
    TileType[TileType["OTEC_PLATFORM"] = 59] = "OTEC_PLATFORM";
    // THE SECOND LANDMARK, and the second tile a latitude band decides
    // (2026-08-30). A seep collector generates nothing either - it is a
    // dome, a line and a flare stack on ground that is turning to mud - so
    // like the OTEC platform it is deliberately absent from every plant set
    // in PlantTiles.ts and from the fleet tally on the map. What it marks is
    // that somebody went north and put a works on the thaw.
    TileType[TileType["METHANE_CAPTURE_STATION"] = 60] = "METHANE_CAPTURE_STATION";
})(TileType || (TileType = {}));
export const tileTypeToString = {
    [TileType.GREENERY]: 'greenery',
    [TileType.OCEAN]: 'ocean',
    [TileType.CITY]: 'city',
    [TileType.CAPITAL]: CardName.CAPITAL,
    [TileType.COMMERCIAL_DISTRICT]: CardName.COMMERCIAL_DISTRICT,
    [TileType.ECOLOGICAL_ZONE]: CardName.ECOLOGICAL_ZONE,
    [TileType.INDUSTRIAL_CENTER]: CardName.INDUSTRIAL_CENTER,
    [TileType.LAVA_FLOWS]: CardName.LAVA_FLOWS,
    [TileType.MINING_AREA]: CardName.MINING_AREA,
    [TileType.MINING_RIGHTS]: CardName.MINING_RIGHTS,
    [TileType.MOHOLE_AREA]: CardName.MOHOLE_AREA,
    [TileType.NATURAL_PRESERVE]: CardName.NATURAL_PRESERVE,
    [TileType.NUCLEAR_ZONE]: CardName.NUCLEAR_ZONE,
    [TileType.RESTRICTED_AREA]: CardName.RESTRICTED_AREA,
    [TileType.DEIMOS_DOWN]: CardName.DEIMOS_DOWN,
    [TileType.GREAT_DAM]: CardName.GREAT_DAM,
    [TileType.MAGNETIC_FIELD_GENERATORS]: CardName.MAGNETIC_FIELD_GENERATORS,
    [TileType.BIOFERTILIZER_FACILITY]: CardName.BIOFERTILIZER_FACILITY,
    [TileType.METALLIC_ASTEROID]: CardName.METALLIC_ASTEROID,
    [TileType.SOLAR_FARM]: CardName.SOLAR_FARM,
    [TileType.OCEAN_CITY]: CardName.OCEAN_CITY,
    [TileType.OCEAN_FARM]: CardName.OCEAN_FARM,
    [TileType.OCEAN_SANCTUARY]: CardName.OCEAN_SANCTUARY,
    [TileType.DUST_STORM_MILD]: 'Mild Dust Storm',
    [TileType.DUST_STORM_SEVERE]: 'Severe Dust Storm',
    [TileType.EROSION_MILD]: 'Mild Erosion',
    [TileType.EROSION_SEVERE]: 'Severe Erosion',
    [TileType.MINING_STEEL_BONUS]: 'Mining (Steel)',
    [TileType.MINING_TITANIUM_BONUS]: 'Mining (Titanium)',
    [TileType.MOON_MINE]: 'Mine',
    [TileType.MOON_HABITAT]: 'Habitat',
    [TileType.MOON_ROAD]: 'Road',
    [TileType.LUNA_TRADE_STATION]: CardName.LUNA_TRADE_STATION,
    [TileType.LUNA_MINING_HUB]: CardName.LUNA_MINING_HUB,
    [TileType.LUNA_TRAIN_STATION]: CardName.LUNA_TRAIN_STATION,
    [TileType.LUNAR_MINE_URBANIZATION]: CardName.LUNAR_MINE_URBANIZATION,
    [TileType.WETLANDS]: CardName.WETLANDS,
    [TileType.RED_CITY]: CardName.RED_CITY,
    [TileType.MARTIAN_NATURE_WONDERS]: CardName.MARTIAN_NATURE_WONDERS,
    [TileType.CRASHLANDING]: CardName.CRASHLANDING,
    [TileType.MARS_NOMADS]: CardName.MARS_NOMADS,
    [TileType.REY_SKYWALKER]: CardName.REY_SKYWALKER,
    [TileType.MAN_MADE_VOLCANO]: CardName.MAN_MADE_VOLCANO,
    [TileType.NEW_HOLLAND]: CardName.NEW_HOLLAND,
    [TileType.NEURAL_INSTANCE]: 'Neural Instance',
    [TileType.WIND_FARM]: 'Wind Farm',
    [TileType.COAL_PLANT]: 'Coal Plant',
    [TileType.GAS_PLANT]: 'Gas Plant',
    [TileType.NUCLEAR_PLANT]: 'Nuclear Plant',
    [TileType.HYDRO_PLANT]: 'Hydro Plant',
    [TileType.TIDAL_PLANT]: 'Tidal Plant',
    [TileType.GEOTHERMAL_PLANT]: 'Geothermal Plant',
    [TileType.EXTRACTION]: 'Extraction Site',
    [TileType.BIOMASS_PLANT]: 'Biomass Plant',
    [TileType.COAL_CCS_PLANT]: 'Coal Plant with Capture',
    [TileType.GAS_CCS_PLANT]: 'Gas Plant with Capture',
    [TileType.OTEC_PLATFORM]: 'OTEC Platform',
    [TileType.METHANE_CAPTURE_STATION]: 'Methane Capture Station',
};
export const HAZARD_TILES = new Set([TileType.DUST_STORM_MILD, TileType.DUST_STORM_SEVERE, TileType.EROSION_MILD, TileType.EROSION_SEVERE]);
export const OCEAN_UPGRADE_TILES = new Set([TileType.OCEAN_CITY, TileType.OCEAN_FARM, TileType.OCEAN_SANCTUARY, TileType.NEW_HOLLAND]);
export const CITY_TILES = new Set([TileType.CITY, TileType.CAPITAL, TileType.OCEAN_CITY, TileType.RED_CITY, TileType.NEW_HOLLAND]);
export const OCEAN_TILES = new Set([TileType.OCEAN, TileType.OCEAN_CITY, TileType.OCEAN_FARM, TileType.OCEAN_SANCTUARY, TileType.WETLANDS, TileType.NEW_HOLLAND]);
export const BASE_OCEAN_TILES = new Set([TileType.OCEAN, TileType.WETLANDS]);
export const GREENERY_TILES = new Set([TileType.GREENERY, TileType.WETLANDS]);
